export const PAGE_GROUPS = [
  { label: "Operations", pages: [{ id: "dashboard", label: "Dashboard" }] },
  {
    label: "Supplier Invoices",
    pages: [
      { id: "invoice_new", label: "Create Supplier Invoice" },
      { id: "invoice_history", label: "Returns to Supplier" },
      { id: "debit_note", label: "Debit Notes" },
      { id: "credit_note", label: "Credit Notes" },
      { id: "supplier_ledger", label: "Supplier Ledger" },
    ],
  },
  {
    label: "Supplementary Cost Processing",
    pages: [
      { id: "supplier_pos", label: "Supplier Purchase Orders" },
      { id: "landed_cost_invoices", label: "Supplementary Cost Invoices" },
      { id: "allocations", label: "Cost Allocations" },
      { id: "customs_duty", label: "Customs Duty & BOE" },
    ],
  },
  { label: "Governance", pages: [{ id: "audit_log", label: "Audit Log" }, { id: "settings", label: "System Settings" }] },
  { label: "Reports", pages: [{ id: "supplier_charges_report", label: "Supplier Charges Report" }] },
];

export const isAdmin = (user) => ["admin", "super_admin"].includes(user?.role);
export const hasPageAccess = (user, page) => isAdmin(user) || user?.allowed_pages?.includes(page);
export const isPendingAccess = (user) => user?.role === "user" && !user?.allowed_pages?.length;